import { restApiDP } from "@plannel/services/utils/rest-api";

// BF 알고리즘 룰 (z_bf_algo_rule). 설계: saas-ai/docs/bf-algo-rule-table-design.md
// CSV 업로드는 데이터 통합 > 데이터 관리 > CSV 가져오기(bfAlgoRule), 엑셀 내보내기는 getAllForCSV(조합 단위, 화면 컬럼 그대로)

const list = () => {
    return restApiDP.get("/api/bf-algo-rules");
};

// 규칙 관리 화면 — 룰을 현재 마스터로 전개한 거래처 x 품목 조합 페이지 조회 (계층 id 목록·ruleIds 라 POST body)
const page = (params) => {
    return restApiDP.post("/api/bf-algo-rules/combos", params);
};

// 엑셀 내보내기(ExcelExportButton) — page 와 같은 필터로 전체 조합 (페이징 없음)
const getAllForCSV = (params) => {
    return restApiDP.post("/api/bf-algo-rules/combos/csv", params);
};

// 인라인 수정 저장 — models 만 갱신
const updateModels = (rules) => {
    return restApiDP.post("/api/bf-algo-rules/update-models", rules);
};

// 화면 저장: 카드 범위 룰(전개 없이 범위 그대로) + 보존할 정확 지정 행 → 전체 교체
const replaceScoped = (scopedRules, exactRules) => {
    return restApiDP.post("/api/bf-algo-rules/replace-scoped", { scopedRules, exactRules });
};

const remove = (ids) => {
    return restApiDP.post("/api/bf-algo-rules/delete", ids);
};

const bfAlgoRuleService = {
    list,
    page,
    getAllForCSV,
    updateModels,
    replaceScoped,
    remove,
};

export default bfAlgoRuleService;
